<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customerStyleImageProposal" @changeIsOperationPossible="changeIsOperationPossible">
      <div class="base-color mh-550 shadow">
        <b-overlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <div class="col-sm-12 row">
              <div class="col-sm-6 p-3 mt-2">
                <span>お好みの画像を選択してください。</span>
              </div>
            </div>
            <div class="col-sm-12 overflow-auto">
              <div class="card-columns p-3 w-100 image-column-count" v-for="(styleImages, index) in showStyleData" :key="index">
                <div class="card position-relative border-0 bg-unset pb-100 card-sqr-gray" v-for="(styleImage, i) in styleImages" :key="i">
                  <div class="p-0" @click="selectImage(styleImage.imageId, styleImage.styleNumber)">
                    <div>
                      <img :src="styleImage.imagePath" class="w-100 ar-3-2" :ref="styleImage.imageId">
                      <img src="~@/assets/img/heart-active.png" class="position-absolute like-icon" style="right: 10px; top: 10px;" v-show="selectedImages.indexOf(styleImage.imageId) >= 0">
                      <img src="~@/assets/img/heart-passive.png" class="position-absolute like-icon" style="right: 10px; top: 10px;" v-show="selectedImages.indexOf(styleImage.imageId) === -1">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </CustomerMeetingLayout>
    <SelectStyleImageMove ref="styleImageMove"></SelectStyleImageMove>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import SelectedStyleImage from '@/components/SelectedStyleImage'
import SelectStyleImageMove from '@/components/SelectStyleImageMove'
import SignalingModel from '@/models/SignalingModel'
import mstore from '@/store/meeting-store'
import cstore from '@/store/customer-store'

import Vue from 'vue'

export default {
  name: 'CustomerMeetingStyleImageProposal',
  components: { CommonLayout, CustomerMeetingLayout, SelectStyleImageMove },
  data () {
    return {
      overlayShow: false,
      selectedImages: [],
      showStyleData: [],
      imageRowMaxNum: 3,
      showImageIds: [],
      isSendFirstSignalingData: false,
      initImages: [],
      selectedList: {},
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.isSendFirstSignalingData = true

        // 接続確立しmeetingSessionが確立した後に要求を送る
        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          // 画面リロード時に情報の再送要求
          SignalingModel.sendAgainEvent()
        }
      }
    },
    getSignalingData: async function (newData, oldData) {
      if (newData['event'] === 'again') {
      // フローリストからのシグナリングのみ受け入れる
        if (newData['data'] === 'fromFlorist') {
          // お客様画面の選択情報を復活させる
          SignalingModel.sendClickEvent('select-image-0', this, {'selected': this.selectedList})
          // 情報の再送要求
          SignalingModel.sendAgainEvent()
        }
        return null
      }

      if (newData['id'] !== 'reDrawMemoImage' && newData['current_path'] && oldData) {
        const synchPass = newData['current_path'].replace('florist', 'customer')
        if (synchPass !== this.$route.path) {
          return this.$router.push(synchPass)
        }
      }

      if (newData['event'] === 'click') {
        if (newData['id'] === 'next') {
          // 画面遷移時に商品一覧のスクロール位置を削除
          sessionStorage.removeItem('proposalScrollHistoryFlag')
          sessionStorage.removeItem('scrollY')
          if (newData['target_path'] !== this.$route.path) {
            this.$router.push(newData['target_path'])
          }
        }
        if (newData['id'] === 'reload') {
          // 現在の選択値を退避
          this.selectedList = {}
          for (let value of Object.values(this.selectedImages)) {
            let img = document.getElementById('selected-image-' + value).getElementsByTagName('img')[0]
            this.selectedList[value] = {
              'url': img.getAttribute('src'),
              'styleNumber': img.dataset.styleNumber
            }
          }

          this.showImageIds = []
          this.showStyleData = []
          this.selectedImages = []
          this.initImages = []

          const selectedStyleImages = document.getElementById('selected-style-images')
          while (selectedStyleImages.firstChild) {
            selectedStyleImages.removeChild(selectedStyleImages.firstChild)
          }
        }
        if (newData['id'] === 'reDrawMemoImage') {
          localStorage.currentProjectType = newData['projectType']
          localStorage.suggestionType = newData['suggestionType']
          const tableRowId = 'tableRowId' in newData && newData['tableRowId'] ? newData['tableRowId'] : ''
          const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
          this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'tableRowId': tableRowId}})
        }
        if (sessionStorage.customerType !== this.consts.customerType.guest) {
          if (newData['id'] === 'operationInvalid') {
            cstore.commit('setIsOperationPossible', false)
          } else if (newData['id'] === 'operationPossible') {
            cstore.commit('setIsOperationPossible', true)
          }
        }
        if (newData['id'] === 'priceHide') {
          cstore.commit('setCustomerDisplayFlag', false)
          this.customerDisplayFlag = cstore.getters.customerDisplayFlag
        } else if (newData['id'] === 'priceDisplay') {
          cstore.commit('setCustomerDisplayFlag', true)
          this.customerDisplayFlag = cstore.getters.customerDisplayFlag
        }
        if (newData.selected) {
          const selectedStyleImages = document.getElementById('selected-style-images')
          while (selectedStyleImages.firstChild) {
            selectedStyleImages.removeChild(selectedStyleImages.firstChild)
          }
          this.selectedImages = Object.keys(newData.selected)
          Object.keys(newData.selected).forEach((id) => {
            let Klass = Vue.extend(SelectedStyleImage)
            let instance = new Klass({
              propsData: {
                url: newData.selected[id].url,
                imageRef: id,
                styleNumber: newData.selected[id].styleNumber,
                isShowStyleNumber: false
              }
            }).$mount()
            // 選択画像欄に追加
            selectedStyleImages.appendChild(instance.$el)
          })
        }
        if (newData['id'] === 'productDetailFromBookmark') {
          localStorage.currentProjectType = newData['projectType']
          localStorage.suggestionType = newData['suggestionType']
          const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
          this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'suggestionType': newData['suggestionType'], 'fromBookmark': true}})
        }
      }

      if (newData['event'] === 'api') {
        if (newData.data.images === undefined) {
          return
        }
        const imageId = newData.data.images.imageId
        if (this.showImageIds.indexOf(imageId) >= 0) {
          this.showStyleData.forEach((styleData, key) => {
            styleData.forEach((styleImage, k) => {
              if (styleImage.imageId === imageId) {
                styleImage.imagePath = newData.data.images.imagePath
              }
            })
          })
        } else {
          this.showImageIds.push(imageId)
          this.initImages.push(newData.data.images)
          this.setImageColumn(newData.data.images)
        }
      }
    }
  },
  methods: {
    setImageColumn (imageObj) {
      if (this.showStyleData.length === 0) {
        this.overlayShow = false
        this.$set(this.showStyleData, 0, [])
      } else if (this.showStyleData[this.showStyleData.length - 1].length === this.imageRowMaxNum) {
        this.showStyleData[this.showStyleData.length] = []
        this.$set(this.showStyleData, (this.showStyleData.length - 1), [])
      }
      const imagesArr = this.showStyleData[this.showStyleData.length - 1]
      imagesArr.push(imageObj)
      this.$set(this.showStyleData, (this.showStyleData.length - 1), imagesArr)
    },
    selectImage (imageId, styleNumber) {
      // 選択可能の場合のみ
      if (cstore.getters.isOperationPossible) {
        // 選択解除
        if (this.selectedImages.indexOf(imageId) >= 0) {
          this.selectedImages = this.selectedImages.filter(n => n !== imageId)
          let selectedImage = document.getElementById('selected-image-' + imageId)
          // 選択画像欄から削除
          selectedImage.remove()
          this.sendSignalingSelectedImageData(imageId)
        // 選択
        } else if (this.selectedImages.length < this.config.styleImageMaxSelect) {
          this.sendSignalingSelectedImageData(imageId, {
            [imageId]: {
              'url': this.$refs[imageId][0]['currentSrc'],
              'styleNumber': styleNumber
            }
          })
          this.selectedImages.push(imageId)

          let Klass = Vue.extend(SelectedStyleImage)
          let instance = new Klass({
            propsData: {
              url: this.$refs[imageId][0]['currentSrc'],
              imageRef: imageId,
              styleNumber: styleNumber,
              isShowStyleNumber: false
            }
          }).$mount()
          const selectedStyleImages = document.getElementById('selected-style-images')

          const clientRectFrom = this.$refs[imageId][0].getBoundingClientRect()
          const pxFrom = window.pageXOffset + clientRectFrom.left
          const pyFrom = window.pageYOffset + clientRectFrom.top

          const clientRectTo = selectedStyleImages.getBoundingClientRect()
          const pxTo = window.pageXOffset + clientRectTo.left
          const pyTo = window.pageYOffset + clientRectTo.top

          // 移動アニメーション
          this.$refs.styleImageMove.move(
            this.$refs[imageId][0]['currentSrc'],
            pyFrom,
            pxFrom,
            pyTo,
            pxTo,
            this.$refs[imageId][0].clientWidth,
            this.$refs[imageId][0].clientHeight
          )

          setTimeout(() => {
            // 移動アニメーション画像リセット
            this.$refs.styleImageMove.restore()
            // 選択画像欄に追加
            selectedStyleImages.appendChild(instance.$el)
          }, 500)
        }
      }
    },
    sendSignalingSelectedImageData (imageId, addURLs) {
      let selectedList = {}
      for (let value of Object.values(this.selectedImages)) {
        let img = document.getElementById('selected-image-' + value).getElementsByTagName('img')[0]
        selectedList[value] = {
          'url': img.getAttribute('src'),
          'styleNumber': img.dataset.styleNumber
        }
      }
      if (addURLs) {
        Object.keys(addURLs).forEach((id) => {
          selectedList[id] = {
            'url': addURLs[id]['url'],
            'styleNumber': addURLs[id]['styleNumber']
          }
        })
      }
      SignalingModel.sendClickEvent('select-image-' + imageId, this, {'selected': selectedList})
    },
    changeIsOperationPossible (value) {
      this.isOperationPossible = value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerMeetingStyleImageProposal.vue